export enum ContactProfileService {
    Sale = 1,
    Rent = 2,
    Purchase = 3,
    Lease = 4,
}

type EntityId = number | string
type EntityIdValue = EntityId | ''
type EntityIdList = EntityIdValue[]

export interface ContactProfileData {
    contact_profile_service_id: EntityIdValue
    property_type_id: EntityIdValue
    area_from?: string | number
    area_to?: string | number
    automatic_offer_enabled?: boolean
    bedrooms_from?: string | number
    bedrooms_to?: string | number
    city_id?: EntityIdList
    company_definition_id?: EntityIdValue
    construction_year_from?: string | number
    construction_year_to?: string | number
    contact_definition_id?: EntityIdValue
    contact_financing_id?: EntityIdList
    contact_id?: EntityIdValue
    contact_profile_duration_id?: EntityIdValue
    contact_profile_remark_id?: EntityIdList
    contact_profile_status_id?: EntityIdValue
    country_id?: EntityIdValue
    county_id?: EntityIdValue
    exclude_basement?: boolean | number
    exclude_last_floor?: boolean | number
    floor_from?: string | number
    floor_to?: string | number
    id?: EntityIdValue
    island_id?: EntityIdList
    price_from?: string | number
    price_m2_from?: string | number
    price_m2_to?: string | number
    price_to?: string | number
    property_descriptions_id?: EntityIdList
    property_equipment_id?: EntityIdList
    property_floor_id?: EntityIdValue
    property_floor_position_id?: EntityIdList
    property_heating_id?: EntityIdList
    property_space_id?: EntityIdList
    property_sub_type_id?: EntityIdList
    property_utility_id?: EntityIdList
    quarter_id?: EntityIdList
    rooms_from?: string | number
    rooms_to?: string | number
    special_request?: string
    wider_area_id?: EntityIdList
}

export interface ContactProfileMutationPayload {
    profileId?: EntityId
    data: ContactProfileData
    isEdit: boolean
    contactId: EntityId
}

export interface ContactProfilePayload {
    contactId: EntityId
    profileId: EntityId
}

export interface ContactProfileListPayload {
    contactId: EntityId
    criteria?: {
        contactProfileService?: number[]
    }
}
